import styled from 'styled-components';
import { Card, Divider, List, Typography } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

export const EnhancedDropdownLayoutCardWrapper = styled(Card)<{ fullwidth?: boolean }>`
  &&& {
    box-shadow: 0 9px 28px 8px #0000000d, 0 3px 6px -4px #0000001f, 0 6px 16px 0 #00000014;
    max-width: ${({ fullwidth }) => (fullwidth ? '320px' : '640px')};
    max-height: 500px;
    box-sizing: border-box;
  }

  .ant-card-actions {
    padding: 0 15px;
  }

  .ant-card-head {
    padding: 0;
    min-height: 48px;
  }

  .ant-card-body {
    padding: 0;
  }
`;

export const EnhancedDropdownLayoutCardHeader = styled(Typography.Text)`
  padding: 0 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  min-width: 319.5px;
  width: 100%;
  box-sizing: border-box;
`;

export const EnhancedDropdownLayoutCardBody = styled.div`
  min-width: 319.5px;
  width: 100%;
  box-sizing: border-box;
`;

export const EnhancedDropdownLayoutDivider = styled(Divider)`
  margin: 0;
  min-height: 48px;
  height: inherit;
`;

export const EnhancedDropdownLayoutSearchIcon = styled(SearchOutlined)`
  color: ${({ theme }) => theme.colorPrimary};
`;

export const EnhancedDropdownLayoutEmptySelected = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colorTextDescription};
  padding: 15px;
`;

export const EnhancedDropdownLayoutDeleteSelectedButton = styled(CloseOutlined)`
  color: ${(props) => props.theme.colorIcon};
  cursor: pointer;
`;

export const EnhancedDropdownLayoutItem = styled(List.Item)`
  &&& {
    padding: 5px 10px;
    border-bottom: 0;

    .ant-list-item-action {
      margin-inline-start: 0;
    }
  }
`;

export const EnhancedDropdownLayoutItemText = styled.span`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
